import React from 'react';
import { ColorPopover } from '../../../components/Popover/ColorPopover';
import { useUserDefaultColor } from '../../Properties/integration/UserSettingsIntegration';

/**
 * UserColorPreference component that manages the user's default object color
 * using the centralized UserColorService
 */
export const UserColorPreference: React.FC = () => {
  const { colorObject, setColorObject } = useUserDefaultColor();

  return (
    <div className="flex items-center w-full">
      <ColorPopover value={colorObject} onChange={setColorObject} />
    </div>
  );
};
